export default "__VITE_ASSET__51fcf6fd__"